<template>
  <div style="min-width: 1400px"
       class="big">
    <div class="page_title">医生意见反馈</div>
    <div style="padding: 20px">
      <div class="container">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="医生意见反馈列表"
                       name="1"
                       lazy>
            <DocMsg :isFlag="doc_msg"
                    :doctorId="doctorId"></DocMsg>
            <div style="display: flex;align-items: center;padding-bottom: 10px;">
              <span>是否结单</span>
              <el-radio-group v-model="activeName"
                              @change="handleClick"
                              style="padding:2px 0 0 10px">
                <el-radio label="1">未结单</el-radio>
                <el-radio label="2">已结单</el-radio>
              </el-radio-group>
            </div>
            <div>
              <template v-if="activeName == 1">
                <!-- 筛选项 -->
                <div class="filterBox flex">
                  <div class="box flex">
                    <div class="label">医生姓名</div>
                    <el-input v-model="doctor_name"
                              size="small"
                              style="width: 130px"
                              @input="search" />
                  </div>
                  <div class="box flex">
                    <div class="label">推荐人姓名</div>
                    <el-input v-model="recommender_name"
                              size="small"
                              style="width: 100px"
                              @input="search" />
                  </div>
                  <div class="box flex">
                    <div class="label">手机号</div>
                    <el-input v-model="phone"
                              size="small"
                              style="width: 100px" />
                  </div>
                  <div class="box flex">
                    <div class="label">提交时间</div>
                    <el-date-picker size="small"
                                    v-model="time1"
                                    type="daterange"
                                    range-separator="~"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    @input="search"></el-date-picker>
                  </div>
                  <div class="box flex">
                    <div class="label">工单号</div>
                    <el-input v-model="f_code"
                              size="small"
                              style="width: 100px" />
                  </div>
                  <el-button type="info"
                             class="search-button"
                             @click="search"
                             size="small">查询</el-button>
                </div>
                <div class="filterBox flex">
                  <div class="box flex align-center">
                    <div class="label">问题类型</div>
                    <el-radio-group v-model="type"
                                    @change="search">
                      <el-radio :label="0">全部</el-radio>
                      <el-radio :label="1">一键反馈</el-radio>
                      <el-radio :label="2">奖励咨询</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="box flex align-center"
                       style="margin-right: 20px">
                    <div class="label">是否绑定：</div>
                    <el-radio-group v-model="is_bind"
                                    @change="search">
                      <el-radio :label="0">全部</el-radio>
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </div>
                  <div>
                    <span style="margin-right: 10px">是否测试医生</span>
                    <el-radio-group v-model="is_test"
                                    @change="search">
                      <el-radio :label="0">全部</el-radio>
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 表格 -->
                <div style="border: solid 1px #c9cbd6">
                  <el-table ref="multipleTable"
                            :data="tableData"
                            tooltip-effect="dark"
                            style="width: 100%; min-width: 1000px"
                            :header-cell-style="{ background: '#F5F5F5' }">
                    <el-table-column prop="create_time"
                                     label="提交时间"
                                     width="180" />
                    <el-table-column prop="f_code"
                                     label="工单号" />
                    <el-table-column label="问题类型">
                      <template slot-scope="scope">
                        <span v-show="scope.row.type == 1">一键反馈</span>
                        <span v-show="scope.row.type == 2">奖励咨询</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="医生信息">
                      <template slot-scope="scope">
                        <div @click="showDocMsg(scope.row.doctor_id)"
                             style="cursor:pointer">{{ scope.row.doctor_name }}</div>
                        <div class="flex">
                          <span>{{ scope.row.sex }}</span>
                          <span style="margin-left: 10px">{{
                        scope.row.title
                      }}</span>
                        </div>
                        <div>{{ scope.row.doctor_phone }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="content"
                                     label="意见反馈"
                                     width="240" />
                    <el-table-column label="推荐人信息">
                      <template slot-scope="scope">
                        <div v-if="scope.row.recommender_name">
                          {{ scope.row.recommender_name }}
                        </div>
                        <div v-if="scope.row.phone">{{ scope.row.phone }}</div>
                        <div v-if="!scope.row.recommender_name">未绑定</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="address"
                                     label="操作">
                      <template slot-scope="scope">
                        <el-button type="text"
                                   @click="setConfirm(scope.row)"
                                   :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('150')
                          : false
                      ">结单</el-button>
                        <el-button type="text"
                                   @click="setBind(scope.row.id)"
                                   v-show="!scope.row.recommender_name"
                                   :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('151')
                          : false
                      ">绑定</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>

              <template v-if="activeName == 2">
                <div class="filterBox flex">
                  <div class="box flex">
                    <div class="label">医生姓名</div>
                    <el-input v-model="doctor_name"
                              size="small"
                              style="width: 130px"
                              @input="search" />
                  </div>
                  <div class="box flex">
                    <div class="label">推荐人姓名</div>
                    <el-input v-model="recommender_name"
                              size="small"
                              style="width: 100px"
                              @input="search" />
                  </div>
                  <div class="box flex">
                    <div class="label">手机号</div>
                    <el-input v-model="phone"
                              size="small"
                              style="width: 100px" />
                  </div>
                  <div>
                    <span style="margin-right: 10px">是否测试医生</span>
                    <el-radio-group v-model="is_test"
                                    @change="search">
                      <el-radio :label="0">全部</el-radio>
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="filterBox flex">
                  <div class="box flex">
                    <div class="label">提交时间</div>
                    <el-date-picker size="small"
                                    v-model="time1"
                                    type="daterange"
                                    range-separator="~"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    @input="search"></el-date-picker>
                  </div>

                  <div class="box flex">
                    <div class="label">结单时间</div>
                    <el-date-picker size="small"
                                    v-model="time2"
                                    type="daterange"
                                    range-separator="~"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    @input="search"></el-date-picker>
                  </div>
                  <div class="box flex">
                    <div class="label">工单号</div>
                    <el-input v-model="f_code"
                              size="small"
                              style="width: 100px" />
                  </div>
                  <el-button type="info"
                             class="search-button"
                             @click="search"
                             size="small">查询</el-button>
                </div>
                <div class="filterBox flex">
                  <div class="box flex align-center">
                    <div class="label">问题类型：</div>
                    <el-radio-group v-model="type"
                                    @change="search">
                      <el-radio :label="0">全部</el-radio>
                      <el-radio :label="1">一键反馈</el-radio>
                      <el-radio :label="2">奖励咨询</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="filterBox flex">
                  <div class="box flex align-center">
                    <div class="label">是否回访：</div>
                    <el-radio-group v-model="is_return_visit">
                      <el-radio :label="0">全部</el-radio>
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="box flex align-center">
                    <div class="label">是否满意：</div>
                    <el-radio-group v-model="is_satisfied">
                      <el-radio :label="0">全部</el-radio>
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="box flex align-center">
                    <div class="label">是否解决：</div>
                    <el-radio-group v-model="is_solve">
                      <el-radio :label="0">全部</el-radio>
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 表格 -->
                <div style="border: solid 1px #c9cbd6">
                  <el-table ref="multipleTable"
                            :data="tableData"
                            tooltip-effect="dark"
                            style="width: 100%; min-width: 1000px"
                            :header-cell-style="{ background: '#F5F5F5' }">
                    <el-table-column prop="create_time"
                                     label="提交时间"
                                     width="160"
                                     fixed="left" />
                    <el-table-column prop="f_code"
                                     label="工单号"
                                     width="160"
                                     fixed="left" />
                    <el-table-column label="问题类型">
                      <template slot-scope="scope">
                        <span v-show="scope.row.type == 1">一键反馈</span>
                        <span v-show="scope.row.type == 2">奖励咨询</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="医生信息"
                                     width="200">
                      <template slot-scope="scope">
                        <div @click="showDocMsg(scope.row.doctor_id)"
                             style="cursor:pointer">{{ scope.row.doctor_name }}</div>
                        <div class="flex">
                          <span>{{ scope.row.sex }}</span>
                          <span style="margin-left: 10px">{{
                        scope.row.title
                      }}</span>
                        </div>
                        <div>{{ scope.row.doctor_phone }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="content"
                                     label="意见反馈"
                                     width="240" />
                    <el-table-column label="推荐人信息"
                                     width="120">
                      <template slot-scope="scope">
                        <div v-if="scope.row.recommender_name">
                          {{ scope.row.recommender_name }}
                        </div>
                        <div v-if="scope.row.phone">{{ scope.row.phone }}</div>
                        <div v-if="!scope.row.recommender_name">未绑定</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="end_time"
                                     label="结单时间"
                                     width="180" />

                    <el-table-column prop="user_name"
                                     label="结单人员"
                                     width="180" />
                    <el-table-column prop="return_visit"
                                     label="是否回访" />
                    <el-table-column prop="satisfied"
                                     label="是否满意" />
                    <el-table-column prop="solve"
                                     label="是否解决" />
                    <el-table-column prop="remark"
                                     label="备注"
                                     width="180"
                                     fixed="right" />
                  </el-table>
                </div>
              </template>
            </div>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="10"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="totalNum"
                           style="margin:20px 0"></el-pagination>
            <!-- 结单弹窗 -->
            <el-dialog title="请补充医生评价"
                       :visible.sync="confirmShow"
                       width="600px"
                       style="text-align: left"
                       :close-on-click-modal="false"
                       center>
              <div class="content">
                <div class="label">结单人员</div>
                <div>{{ user_name }}</div>
                <div class="label">是否已经有客户回访</div>
                <el-radio-group v-model="return_visit">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
                <div class="label">对回访客服是否满意</div>
                <el-radio-group v-model="satisfied">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
                <div class="label">问题是否得到解决</div>
                <el-radio-group v-model="solve">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
                <div class="label">备注</div>
                <div>
                  <el-input type="textarea"
                            :rows="6"
                            :maxlength="500"
                            show-word-limit
                            placeholder="请输入内容"
                            v-model="remark">
                  </el-input>
                </div>
              </div>
              <span slot="footer"
                    class="dialog-footer">
                <el-button @click="confirmShow = false"
                           size="small">取消</el-button>
                <el-button type="primary"
                           @click="statementDoctorFeedback"
                           size="small">确 定</el-button>
              </span>
            </el-dialog>

            <!-- 绑定联系人弹窗 -->
            <el-dialog title="绑定联系人弹窗"
                       :visible.sync="bindShow"
                       width="800px"
                       style="text-align: left"
                       :close-on-click-modal="false"
                       center>
              <div class="content">
                <div class="filterBox flex wrap">
                  <div class="box flex align-center">
                    <div class="label">姓名</div>
                    <el-input v-model="dialog_name"
                              size="small"
                              style="width: 150px"
                              :maxlength="8"
                              @input="searchRecommender" />
                  </div>

                  <div class="box flex align-center">
                    <div class="label">手机号</div>
                    <el-input v-model="dialog_phone"
                              size="small"
                              style="width: 150px"
                              :maxlength="8" />
                  </div>
                  <div class="box flex align-center">
                    <div class="label">邀请码</div>
                    <el-input v-model="recommender_code"
                              size="small"
                              style="width: 150px"
                              :maxlength="8" />
                  </div>
                  <el-button type="info"
                             class="search-button"
                             @click="searchRecommender"
                             size="small">查询</el-button>
                </div>
                <p class="red">选择已绑定的医生，将解除医生与原推荐人的绑定关系</p>
                <div style="border: solid 1px #c9cbd6">
                  <el-table ref="multipleTable"
                            :data="recommenderlist"
                            tooltip-effect="dark"
                            style="width: 100%"
                            height="300px"
                            :header-cell-style="{ background: '#F5F5F5' }">
                    <el-table-column label="选择">
                      <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.checked"
                                     @change="
                    (val) => recommenderChange(val, scope.row.recommender_code)
                  " />
                      </template>
                    </el-table-column>
                    <el-table-column prop="recommender_name"
                                     label="邀请人姓名" />
                    <el-table-column prop="recommender_code"
                                     label="邀请码" />
                    <el-table-column prop="phone"
                                     label="手机号" />
                  </el-table>
                </div>
              </div>
              <span slot="footer"
                    class="dialog-footer">
                <el-button type="primary"
                           @click="bindRecommender"
                           size="small">确 定</el-button>
              </span>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane label="医生投诉"
                       name="2"
                       lazy>
            <DoctorComplain></DoctorComplain>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

  </div>

</template>
<script>
import moment from 'moment';
import DocMsg from '../../../components/common/DocMsg.vue';
import DoctorComplain from '../doctorcomplain/DoctorComplain.vue';
export default {
  components: {
    DocMsg,
    DoctorComplain
  },
  data() {
    return {
      activeTab: '1',
      activeName: '1',
      doctor_name: '',
      recommender_name: '',
      phone: '',
      f_code: '',
      type: 0, //问题类型
      is_bind: 0,
      is_return_visit: '',
      user_name: '',
      remark: '',
      is_satisfied: '',
      is_solve: '',
      time1: [],
      time2: [],
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      confirmShow: false,
      bindShow: false,
      return_visit: 1,
      satisfied: 1,
      solve: 1,
      current_id: '', //结单的医生id
      recommender_code: '',
      dialog_name: '',
      dialog_phone: '',
      recommenderlist: [],
      currentCode: '',
      is_test: 2,
      doc_msg: false,
      doctorId: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取认证记录列表
    getList() {
      let data = {
        statement_status: Number(this.activeName),
        doctor_name: this.doctor_name,
        recommender_name: this.recommender_name,
        phone: this.phone,
        f_code: this.f_code,
        is_bind: this.is_bind,
        is_return_visit: this.is_return_visit,
        is_satisfied: this.is_satisfied,
        is_solve: this.is_solve,
        page: this.currentPage,
        pageNumber: this.pagesize,
        is_test: this.is_test,
        type: this.type
      };
      if (this.time1 && this.time1.length > 0) {
        data.submit_start_time = moment(this.time1[0]).format('YYYY-MM-DD');
        data.submit_end_time = moment(this.time1[1]).format('YYYY-MM-DD');
      }
      if (this.time2 && this.time2.length > 0) {
        data.statement_start_time = moment(this.time2[0]).format('YYYY-MM-DD');
        data.statement_end_time = moment(this.time2[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/activity/getDoctorFeedbackList', data)
        .then((res) => {
          if (!res.data.list.length && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this.getList();
          }
          let list = res.data.list;
          list.forEach((ele) => {
            if (ele.create_time) {
              ele.create_time = moment
                .unix(ele.create_time)
                .format('YYYY-MM-DD HH:mm');
            }
            if (ele.end_time) {
              ele.end_time = moment
                .unix(ele.end_time)
                .format('YYYY-MM-DD HH:mm');
            }
            ele.sex = ele.sex == 1 ? '男' : '女';
            ele.return_visit = ele.return_visit == 1 ? '是' : '否';
            ele.satisfied = ele.satisfied == 1 ? '是' : '否';
            ele.solve = ele.solve == 1 ? '是' : '否';
          });
          this.totalNum = res.data.total;
          this.tableData = list;
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //tab切换
    handleClick() {
      this.currentPage = 1;
      this.is_bind = 0;
      this.time1 = [];
      this.doctor_name = '';
      this.recommender_name = '';
      this.phone = '';
      this.f_code = '';
      this.is_return_visit = 0;
      this.is_satisfied = 0;
      this.is_solve = 0;
      this.time2 = [];
      this.type = 0;
      this.getList();
    },
    //打开结单弹窗
    setConfirm(row) {
      let { id, remark } = row;
      this.current_id = id;
      this.return_visit = 1;
      this.satisfied = 1;
      this.solve = 1;
      this.user_name = this.$store.state.userInfo.userInfo.real_name
        ? this.$store.state.userInfo.userInfo.real_name
        : this.$store.state.userInfo.userInfo.user_name;
      this.remark = remark;
      this.confirmShow = true;
    },
    //打开绑定弹窗
    setBind(id) {
      this.current_id = id;
      this.dialog_name = '';
      this.dialog_phone = '';
      this.recommender_code = '';
      this.bindShow = true;
      this.searchRecommender();
    },
    //提交结单
    statementDoctorFeedback() {
      let data = {
        id: this.current_id,
        return_visit: this.return_visit,
        satisfied: this.satisfied,
        solve: this.solve,
        remark: this.remark
      };
      this.axios
        .post('platform/activity/statementDoctorFeedback', data)
        .then((res) => {
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.getList();
          this.confirmShow = false;
        });
    },
    //搜索联系人
    searchRecommender() {
      let data = {
        recommender_name: this.dialog_name,
        phone: this.dialog_phone,
        recommender_code: this.recommender_code,
        page: 1,
        pageNumber: 500
      };
      this.axios
        .post('platform/activity/searchRecommender', data)
        .then((res) => {
          let list = res.data.list;
          list.forEach((ele) => {
            ele.checked = false;
          });
          this.recommenderlist = list;
        });
    },
    recommenderChange(val, code) {
      this.currentCode = code;
    },
    bindRecommender() {
      if (!this.currentCode) {
        this.$message({
          message: '请选择一位推荐人'
        });
        return;
      }
      let data = {
        id: this.current_id,
        recommender_code: this.currentCode
      };
      this.axios.post('platform/activity/bindRecommender', data).then((res) => {
        this.$message({
          message: '绑定成功',
          type: 'success'
        });
        this.getList();
        this.currentCode = '';
        this.bindShow = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 10px 20px 20px 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  line-height: 32px;
  height: 32px;
  margin-bottom: 20px;
  .box {
    line-height: 32px;
    height: 32px;
    margin-right: 20px;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
  }
}
</style>
<style lang="scss">
.el-image > img {
  height: 100px;
  width: auto;
  display: block;
}
.el-image-viewer__close {
  i {
    color: #ffffff;
  }
}
.el-dialog .content {
  padding: 20px;
  .label {
    color: #262626;
    font-weight: bold;
    font-size: 14px;
    margin: 15px 0 10px 0;
  }
  .el-radio-group {
    margin-bottom: 10px;
  }
}
</style>


